import React, {
    ReactElement,
  } from 'react';
  import {
    Routes,
    Route,
  } from 'react-router-dom';
  import ProfExpHomePage from './profexp_home_page';
  import ProfExpSubmit from './submit_profexp';
  import ErrorPage from 'error_page';
  
  /**
   * Component for textbooks page. The textbooks page consists of a picture of saul goodman
   *
   * @returns {ReactElement} the textbooks page component.
   */
  
  export default function ProfExpPage() {
    return (
      <Routes>
        <Route exact path="/" element={<ProfExpHomePage />} />
        <Route exact path="/submit-professional-experiences" element={<ProfExpSubmit />} />
        <Route exact path="*" element={<ErrorPage />} />
      </Routes>
    );
  }
  